<template>
  <div class="modal" :data-visible="visible">
    <div class="modal-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  data() {
    return {
      visible: false,
      onShow: null,
      onHide: null
    }
  },
  mounted() {

  },
  methods: {
    show() {
      if (this.visible) {
        return;
      }
      this.visible = true

      document.addEventListener('keyup', this.handleKeyUp)

      if (this.onShow) {
        this.onShow();
      }
    },
    hide() {
      if (!this.visible) {
        return;
      }
      this.visible = false

      document.removeEventListener('keyup', this.handleKeyUp)

      if (this.onHide) {
        this.onHide();
      }
    },
    toggle() {
      if (this.visible) {
        this.hide();
      } else {
        this.show();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .modal {
    overflow: hidden;
    max-height: 0;

    transition: max-height 0.2s ease-in-out;

    &[data-visible="true"] {
      max-height: 200vh;
    }
  }
</style>
